<template>
  <div>
    <el-form ref="form" :model="options" >
      <el-form-item label="Libellé" >
        <el-input v-model="options.name" />
      </el-form-item>
      <el-form-item label="Page d'accueil" >
        <el-select v-model="options.home" :clearable="true" value-key="id" >
          <el-option v-for="board in boards" :key="board.id" :label="board.name" :value="board" />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="!!options.home"
        label="Masquer le board par défaut" >
        <el-switch v-model="options.hideDefault" />
      </el-form-item>
      <el-form-item label="Public" >
        <el-switch v-model="options.public" />
      </el-form-item>
    </el-form>
    <div class="footer" >
      <el-button @click="$emit('cancel')" type="warning" icon="el-icon-close" >
        Annuler
      </el-button>
      <el-button @click="$emit('save', options)" type="success" icon="el-icon-check" >
        Valider
      </el-button>
    </div>
  </div>
</template>

<script>
import {api} from 'macarons'

export default {
  props: {
    contract: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      options: {
        name: this.contract.name,
        hideDefault: this.contract.hideDefault,
        crisp: false,
        home: this.contract.home,
        'public': this.contract['public']
      },
      boards: []
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    contract: {
      handler: function () {
        this.options.name = this.contract.name
        this.options['public'] = this.contract['public']
        this.options.crisp = this.contract.crisp
        this.options.hideDefault = this.contract.hideDefault
        this.options.home = this.contract.home
        this.load()
      },
      deep: true
    }
  },
  methods: {
    load () {
      api.get('contract/' + this.contract.id + '/boards').then(({data}) => {
        this.boards.splice(0, this.boards.length, ...data)
      })
    }
  }
}
</script>

<style scoped>
.footer {
    text-align: right;
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/contracts/components/ContractOptions.vue